var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
var height = window.innerHeight > 0 ? window.innerHeight : screen.height;

let animationInterval = 4000;
let animationExpired = 20000;

let leftMobile = Math.floor((Math.random() * width) / 4);

function randomInteger(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
const createSquare = () => {
  const section = document.querySelector('body.animatedBg');
  const square = document.createElement('span');
  square.className = 'square';
  let sizeDesktop = '300px';

  square.style.width = sizeDesktop;
  square.style.height = sizeDesktop;
  square.style.top = '-10%';
  square.style.left = randomInteger(10, 40) + '%';

  section && section.appendChild(square);
  setTimeout(() => {
    square && square.remove();
  }, animationExpired);
};

if (width > 400) {
  createSquare();
  setInterval(() => {
    createSquare();
  }, animationInterval);
}
